import React, { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import LeaveConfirmModal from "../pages/child/Modal/LeaveConfirmModal";

const LeaveConfirmContext = createContext();

export const ScreenLockProvider = ({ children }) => {
    const [vipCode, setVipCodeHandle] = useState("");
    const [isDirty, setIsDirty] = useState(false);
    const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);
    const [pendingAction, setPendingAction] = useState(null);
    const navigate = useNavigate();

    const setVipCode = (value) => {
        setVipCodeHandle(value);
    };

    const navigateWithConfirm = (target) => {
        const action = typeof target === "function" ? target : () => navigate(target);
        const hasUnsavedChanges = (vipCode && vipCode !== "") || isDirty;

        if (hasUnsavedChanges) {
            setPendingAction(() => action);
            setShowLeaveConfirm(true);
        } else {
            action();
        }
    };

    const handleLeaveCancel = () => {
        setPendingAction(null);
        setShowLeaveConfirm(false);
    };

    const handleLeaveConfirmed = () => {
        setShowLeaveConfirm(false);
        setVipCodeHandle("");
        setIsDirty(false);
        const action = pendingAction;
        setPendingAction(null);
        if (action) {
            action();
        }
    };

    return (
        <LeaveConfirmContext.Provider
            value={{
                vipCode,
                setVipCode,
                isDirty,
                setIsDirty,
                navigateWithConfirm,
                showLeaveConfirm,
                setShowLeaveConfirm,
            }}
        >
            {children}
            <LeaveConfirmModal
                show={showLeaveConfirm}
                onCancel={handleLeaveCancel}
                onConfirm={handleLeaveConfirmed}
            />
        </LeaveConfirmContext.Provider>
    );
};

export const useLeaveConfirm = () => {
    const context = useContext(LeaveConfirmContext);
    if (!context) {
        throw new Error("useLeaveConfirm must be used within a ScreenLockProvider");
    }
    return context;
};

export const LeaveConfirmProvider = ScreenLockProvider;

export default LeaveConfirmContext;
